import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { useApi } from "shared/hooks/useApi";
import { ENDPOINTS } from "shared/types/enums";

import File from "../../../../../../../TableDetails/components/File";
import SingleDataItem from "../../../SingleDataItem";
import { ListProps } from "../types";
import Loader from "./Loader";

const List = ({ title, ids }: ListProps) => {
    const { t } = useTranslation();
    const { getData, handleResponse } = useApi();

    const [files, setFiles] = useState<{}[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const getFiles = async () => {
            const getEndpoints = () =>
                ids.map(id => getData(`${ENDPOINTS.Files}/${id}`));

            const endpoints = getEndpoints();

            try {
                const response = await Promise.all(endpoints);

                const allFiles = response.map(({ data }) => {
                    return data;
                });

                setFiles(allFiles);
            } catch (error) {
                handleResponse(error);
            }

            setIsLoading(false);
        };

        getFiles();
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <h4
                css={css({
                    marginTop: "20px"
                })}
            >
                {title}
            </h4>

            {isLoading
                ? ids.map(id => <Loader key={id} />)
                : files.map((file: any) => (
                      <SingleDataItem
                          key={file.id}
                          name={t(
                              `Attributes##txFwBundleFileTypes##${file.type}`
                          )}
                          data={<File data={file} />}
                          isFirstCentered
                      />
                  ))}
        </>
    );
};

export default List;
